import { useMetaContext } from "provider/MetaProvider";
import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";

const GetQuoteForm = () => {
  const { accommodation } = useMetaContext();
  const [safaris, setSafaris] = useState(0);
  const [travelers, setTravelers] = useState(0);

  return (
    <div className="mb-4 position-relative galssset" id="memberview">
      <div className="getquote_box">
        <div className="get_free_title2 text-center pb-3">
          <h4>Get free Bandhavgarh safari quotes from multiple operators!</h4>
        </div>

        <Form
          id="quoteform"
          action="/operator/ankit-kankane-safaris/sharedsafari"
          method="POST"
        >
          <input
            type="hidden"
            name="_csrf-frontend"
            value="0cGhaxRUU4amZ6XSeFMyK3LniRjW2-FfTzTE76AuyAWat5IOLGAGz8cz1IpOPQRdI5O8NYaTrgcod7WJz1uwVA=="
          />
          <Row className="gx-2">
            <Col xs={12}>
              <div className="form-wrapper">
                <Row>
                  <Col sm={6} xs={12}>
                    <div className="input-group2">
                      <Form.Label>Safaris</Form.Label>
                      <div className="number-input position-relative">
                        <div className="mb-3 field-safaris required">
                          <Form.Control type="text" value={safaris} readOnly />
                          <div className="invalid-feedback"></div>
                        </div>
                        <div className="bton_updown">
                          <button
                            type="button"
                            onClick={() => setSafaris(safaris + 1)}
                          >
                            <i className="fa-solid fa-chevron-up"></i>
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              setSafaris((prev) => Math.max(prev - 1, 0))
                            }
                          >
                            <i className="fa-solid fa-chevron-down"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6} xs={12}>
                    <div className="input-group2">
                      <Form.Label>Travelers</Form.Label>
                      <div className="number-input position-relative">
                        <Form.Control type="text" value={travelers} readOnly />
                        <div className="bton_updown">
                          <button
                            type="button"
                            onClick={() => setTravelers(travelers + 1)}
                          >
                            <i className="fa-solid fa-chevron-up"></i>
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              setTravelers((prev) => Math.max(prev - 1, 0))
                            }
                          >
                            <i className="fa-solid fa-chevron-down"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col lg={12}>
              <div className="form-wrapper">
                <Form.Label className="p-0">Accommodation</Form.Label>
                <Form.Select
                  className="mb-3"
                  name="OperatorQuoteForm[stay_category_id]"
                  required
                >
                  <option
                    value=""
                    className="select2-selection__placeholder"
                    style={{ fontSize: "14px", color: "#9999" }}
                  >
                    Select...
                  </option>
                  {accommodation?.map((item, index) => (
                    <option value={item?.value} key={index}>
                      {item?.label}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Col>

            <Col sm={6} xs={12}>
              <div className="form-wrapper">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="OperatorQuoteForm[start_date]"
                  required
                />
              </div>
            </Col>
            <Col sm={6} xs={12}>
              <div className="form-wrapper">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="OperatorQuoteForm[end_date]"
                  required
                />
              </div>
            </Col>

            <Col lg={12} className="pt-lg-0 content-center">
              <button type="submit" className="sent_btn w-100 mb-3 mt-3">
                Send Request
              </button>
            </Col>
            <Col lg={12}>
              <div className="text_get">
                <p>
                  <span>*</span>We’ll share your request with all operators in
                  the park and send you their quotes.
                </p>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="qoute_write">
                  <h5 className="mb-0 px-lg-5 px-3">comming soon</h5>
                </div>
    </div>
    //     <div className="mb-4" id="memberview" data-select2-id="memberview">
    //       <div className="getquote_box" data-select2-id="11">
    //         <div className="get_free_title2 text-center pb-3">
    //           <h4>Get a FREE quote</h4>
    //         </div>

    //         <form
    //           id="quoteform"
    //           action="/operator/ankit-kankane-safaris/sharedsafari"
    //           method="POST"
    //           data-select2-id="quoteform"
    //         >
    //           <input
    //             type="hidden"
    //             name="_csrf-frontend"
    //             value="0cGhaxRUU4amZ6XSeFMyK3LniRjW2-FfTzTE76AuyAWat5IOLGAGz8cz1IpOPQRdI5O8NYaTrgcod7WJz1uwVA=="
    //           />{" "}
    //           <div className="row gx-2" data-select2-id="10">
    //             <div className="col-lg-12" data-select2-id="9">
    //               <div className="form-wrapper" data-select2-id="8">
    //                 <label for="">Safari Park</label>
    //                 <div
    //                   className="mb-3 field-operatorquoteform-safari_park_id required"
    //                   data-select2-id="7"
    //                 >
    //                   <div className="form-group" data-select2-id="6">
    //                     <select
    //                       id="operatorquoteform-safari_park_id"
    //                       className="form-control select2-hidden-accessible"
    //                       name="OperatorQuoteForm[safari_park_id]"
    //                       aria-required="true"
    //                       data-s2-options="s2options_fd268a17"
    //                       data-krajee-select2="select2_5c45a0ce"
    //                       style={{width: "1px", height: "1px", visibility: "hidden"}}
    //                       data-select2-id="operatorquoteform-safari_park_id"
    //                       tabindex="-1"
    //                       aria-hidden="true"
    //                     >
    //                       <option value="" data-select2-id="2">
    //                         Select park...
    //                       </option>
    //                       <option value="6" data-select2-id="18">
    //                         Bandhavgarh Tiger Reserve
    //                       </option>
    //                       <option value="1" data-select2-id="19">
    //                         Dudhwa Tiger Reserve{" "}
    //                       </option>
    //                       <option value="7" data-select2-id="20">
    //                         Kanha Tiger Reserve
    //                       </option>
    //                       <option value="8" data-select2-id="21">
    //                         Panna Tiger Reserve
    //                       </option>
    //                       <option value="11" data-select2-id="22">
    //                         Sanjay-Dubri Tiger Reserve{" "}
    //                       </option>
    //                     </select>
    //                     <span
    //                       className="select2 select2-container select2-container--krajee-bs5 select2-container--below select2-container--focus"
    //                       dir="ltr"
    //                       data-select2-id="1"
    //                       style={{width: "auto"}}
    //                     >
    //                       <span className="selection">
    //                         <span
    //                           className="select2-selection select2-selection--single"
    //                           role="combobox"
    //                           aria-haspopup="true"
    //                           aria-expanded="false"
    //                           tabindex="0"
    //                           aria-disabled="false"
    //                           aria-labelledby="select2-operatorquoteform-safari_park_id-container"
    //                         >
    //                           <span
    //                             className="select2-selection__rendered"
    //                             id="select2-operatorquoteform-safari_park_id-container"
    //                             role="textbox"
    //                             aria-readonly="true"
    //                           >
    //                             <span className="select2-selection__placeholder">
    //                               Select park...
    //                             </span>
    //                           </span>
    //                           <span
    //                             className="select2-selection__arrow"
    //                             role="presentation"
    //                           >
    //                             <b role="presentation"></b>
    //                           </span>
    //                         </span>
    //                       </span>
    //                       <span className="dropdown-wrapper" aria-hidden="true"></span>
    //                     </span>
    //                     <div className="invalid-feedback"></div>
    //                   </div>
    //                 </div>{" "}
    //               </div>
    //             </div>
    //             <div className="col-lg-12">
    //               <div className="form-wrapper d-flex gap-3">
    //                 <div className="input-group2 ">
    //                   <label for="safaris">Safaris</label>
    //                   <div className="number-input position-relative">
    //                     <div className="mb-3 field-safaris required">
    //                       <div className="form-group">
    //                         <input
    //                           type="text"
    //                           id="safaris"
    //                           className="form-control"
    //                           name="OperatorQuoteForm[safaris]"
    //                           value="0"
    //                           aria-required="true"
    //                         />
    //                         <div className="invalid-feedback"></div>
    //                       </div>
    //                     </div>{" "}
    //                     <div className="bton_updown">
    //                       <button type="button" onclick="increment('safaris')">
    //                         <i className="fa-solid fa-chevron-up"></i>
    //                       </button>
    //                       <button type="button" onclick="decrement('safaris')">
    //                         <i className="fa-solid fa-chevron-down"></i>
    //                       </button>
    //                     </div>
    //                   </div>
    //                 </div>
    //                 <div className="input-group2">
    //                   <label for="travelers">Travelers</label>
    //                   <div className="number-input position-relative">
    //                     <div className="mb-3 field-travelers required">
    //                       <div className="form-group">
    //                         <input
    //                           type="text"
    //                           id="travelers"
    //                           className="form-control"
    //                           name="OperatorQuoteForm[travelers]"
    //                           value="0"
    //                           aria-required="true"
    //                         />
    //                         <div className="invalid-feedback"></div>
    //                       </div>
    //                     </div>{" "}
    //                     <div className="bton_updown">
    //                       <button type="button" onclick="increment('travelers')">
    //                         <i className="fa-solid fa-chevron-up"></i>
    //                       </button>
    //                       <button type="button" onclick="decrement('travelers')">
    //                         <i className="fa-solid fa-chevron-down"></i>
    //                       </button>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="col-lg-12">
    //               <div className="form-wrapper">
    //                 <label for="">Accommodation</label>
    //                 <div className="mb-3 field-operatorquoteform-stay_category_id required">
    //                   <div className="form-group">
    //                     <select
    //                       id="operatorquoteform-stay_category_id"
    //                       className="form-control select2-hidden-accessible"
    //                       name="OperatorQuoteForm[stay_category_id]"
    //                       aria-required="true"
    //                       data-s2-options="s2options_fd268a17"
    //                       data-krajee-select2="select2_e1a902bb"
    //                       style={{width: "1px", height: "1px", visibility: "hidden"}}
    //                       data-select2-id="operatorquoteform-stay_category_id"
    //                       tabindex="-1"
    //                       aria-hidden="true"
    //                     >
    //                       <option value="" data-select2-id="4">
    //                         Select...
    //                       </option>
    //                       <option value="5">Premium</option>
    //                       <option value="6">Standard</option>
    //                       <option value="7">Economical</option>
    //                       <option value="8">Home Stay</option>
    //                       <option value="1">Forest Rest House</option>
    //                       <option value="4">Not Included</option>
    //                     </select>
    //                     <span
    //                       className="select2 select2-container select2-container--krajee-bs5"
    //                       dir="ltr"
    //                       data-select2-id="3"
    //                       style={{width: "auto"}}
    //                     >
    //                       <span className="selection">
    //                         <span
    //                           className="select2-selection select2-selection--single"
    //                           role="combobox"
    //                           aria-haspopup="true"
    //                           aria-expanded="false"
    //                           tabindex="0"
    //                           aria-disabled="false"
    //                           aria-labelledby="select2-operatorquoteform-stay_category_id-container"
    //                         >
    //                           <span
    //                             className="select2-selection__rendered"
    //                             id="select2-operatorquoteform-stay_category_id-container"
    //                             role="textbox"
    //                             aria-readonly="true"
    //                           >
    //                             <span className="select2-selection__placeholder">
    //                               Select...
    //                             </span>
    //                           </span>
    //                           <span
    //                             className="select2-selection__arrow"
    //                             role="presentation"
    //                           >
    //                             <b role="presentation"></b>
    //                           </span>
    //                         </span>
    //                       </span>
    //                       <span className="dropdown-wrapper" aria-hidden="true"></span>
    //                     </span>
    //                     <div className="invalid-feedback"></div>
    //                   </div>
    //                 </div>{" "}
    //               </div>
    //             </div>
    //             <div className="col-lg-6">
    //               <div className="form-wrapper">
    //                 <label for="start-date">Start Date</label>
    //                 <div className="mb-3 field-operatorquoteform-start_date required">
    //                   <div className="form-group">
    //                     <input
    //                       type="date"
    //                       id="operatorquoteform-start_date"
    //                       className="form-control"
    //                       name="OperatorQuoteForm[start_date]"
    //                       aria-required="true"
    //                     />
    //                     <div className="invalid-feedback"></div>
    //                   </div>
    //                 </div>{" "}
    //               </div>
    //             </div>
    //             <div className="col-lg-6">
    //               <div className="form-wrapper">
    //                 <label for="end-date">End Date</label>
    //                 <div className="mb-3 field-operatorquoteform-end_date required">
    //                   <div className="form-group">
    //                     <input
    //                       type="date"
    //                       id="operatorquoteform-end_date"
    //                       className="form-control"
    //                       name="OperatorQuoteForm[end_date]"
    //                       aria-required="true"
    //                     />
    //                     <div className="invalid-feedback" />
    //                   </div>
    //                 </div>
    //               </div>{" "}
    //             </div>
    //           </div>
    //           <div className="col-lg-12 pt-lg-0  content-center">
    //             <button type="submit" className="sent_btn w-100 mb-3 mt-2 ">
    //               Send Request
    //             </button>{" "}
    //           </div>
    //           <div className="col-12 ">
    //             <div className="text_get">
    //               <p className="">
    //                 <span>*</span>Your request will be sent directly to the
    //                 operator, but you can also contact them directly if you prefer.
    //               </p>
    //             </div>
    //           </div>
    //         </form>
    //       </div>

    //       {/* <script>
    //     function increment(id) {
    //         let input = document.getElementById(id);
    //         input.value = parseInt(input.value) + 1;
    //     }

    //     function decrement(id) {
    //         let input = document.getElementById(id);
    //         if (parseInt(input.value) > 0) {
    //             input.value = parseInt(input.value) - 1;
    //         }
    //     }
    // </script> */}
    //     </div>
  );
};

export default GetQuoteForm;
